import React from 'react';

const Separator = ({ h }) => {
    return (
        <div style={{ height: h ? h : '5vh' }} />
    );
};

export default Separator;